import React from 'react';
import { PropTypes } from 'prop-types';
import ContentCard from '../ContentCard';
import Chart from '../../charts/PieChart';
import { DROPDOWNDATA } from './constants';
import { DROPDOWN_VARIANTS } from '../constants';
import { numberWithCommas } from '../utils';
import './styles.scss';
import LoadingComponent from '../LoadingComponent';
import { noop } from '../propTypes';
import PieChartLegend from '../PieChartLegend';

export const getTags = (topTags) => {
    return (
        topTags &&
        topTags.map((topTag, index) => {
            return (
                <li key={`topTag-${index}`}>
                    <PieChartLegend
                        label={`${topTag.tag} (${numberWithCommas(
                            topTag.count,
                        )})`}
                        color={topTag.color}
                    />
                </li>
            );
        })
    );
};

const getTagSum = (tags) => {
    return tags && tags.length
        ? tags.reduce((sum, value) => sum + value.count, 0)
        : 0;
};
function TopTags(
    {
        mlTags,
        showTotal,
        heading,
        subHeading,
        taxonomy,
        tagsLoading,
        onTaxonomySelect,
        permissions,
        downloadable,
        onDownloadClick,
    },
    ref,
) {
    const loader = <LoadingComponent isLoading={tagsLoading} />;

    const tagPills = (
        <div className="col-lg-4 col-xl-5 col-12">
            <div>
                <div className="topTagsWithScroll">
                    <div style={{ fontSize: 20, fontWeight: 600 }}>Top 10</div>
                    <div className="d-flex flex-wrap">
                        {mlTags && mlTags.length ? (
                            <div className="col px-1">
                                <ul className="pills-wrapper p-0">
                                    {getTags(mlTags)}
                                </ul>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );

    const addPieChartData = (selected, data, result) => {
        selected && data && data.length
            ? result.push({
                  data: data,
                  dataKey: 'count',
                  nameKey: 'tag',
              })
            : null;
        return result;
    };

    const pieChart = () => {
        let result = [];
        result = addPieChartData(true, mlTags, result);
        return (
            <div className="col-lg-8 col-xl-7 col-12">
                <Chart width={'125%'} height={400} pieData={result} />
            </div>
        );
    };

    const mainContent = tagsLoading ? (
        loader
    ) : mlTags && mlTags.length ? (
        <div>
            <div className="d-flex flex-wrap">
                <div className="f-wrap">
                    {showTotal ? (
                        <h3 className="title-secondary f-90 mt-2">
                            {getTagSum(mlTags)}
                        </h3>
                    ) : null}
                </div>
            </div>
            <div className="row">
                {tagPills} {pieChart()}
            </div>
        </div>
    ) : (
        <div className="empty-pie-chart">
            <span className="info">No Data Available</span>
        </div>
    );

    const defaultHeading = taxonomy[0]
        ? `Total ${taxonomy.replace(/^./, taxonomy[0].toUpperCase())} Tags`
        : '';

    return (
        <ContentCard
            heading={heading ? heading : defaultHeading}
            subHeading={subHeading}
            showDropDown={true}
            dropDownData={DROPDOWNDATA}
            dropDownLabel={'Filter By'}
            dropDownOnClick={onTaxonomySelect}
            dropDownVariant={DROPDOWN_VARIANTS.LIST_SIMPLE}
            content={mainContent}
            cardSize={7}
            permissions={permissions}
            id="topTags"
            downloadable={downloadable}
            onDownloadClick={onDownloadClick}
            ref={ref}
        />
    );
}

TopTags.propTypes = {
    id: PropTypes.number,
    // user tags to display in pie chart
    topTags: PropTypes.arrayOf(PropTypes.object),
    // ml tags to display in pie chart
    mlTags: PropTypes.arrayOf(PropTypes.object),
    // used to determine if total tags number is to be shown
    showTotal: PropTypes.bool,
    // taxonomy used to display heading
    taxonomy: PropTypes.string,
    // loading state of card
    tagsLoading: PropTypes.bool,
    // function to pass to dropdown when taxonomy is selected
    onTaxonomySelect: PropTypes.func,
    // heading to display on top of card
    heading: PropTypes.string,
    // subheading to display on top of card
    subHeading: PropTypes.string,
    // array of strings which contain user permissions
    permissions: PropTypes.arrayOf(PropTypes.string),
    downloadable: PropTypes.bool,
    onDownloadClick: PropTypes.func,
};

TopTags.defaultProps = {
    id: null,
    heading: null,
    subHeading: '',
    topTags: [],
    mlTags: [],
    totalTags: '0',
    totalMlTags: 0,
    showTotal: true,
    taxonomy: '',
    tagsLoading: false,
    onTaxonomySelect: noop,
    permissions: [],
    downloadable: false,
    onDownloadClick: noop,
};

export default React.forwardRef(TopTags);
